// External
import React, { memo } from "react";

// Relative
import { useAcademicRecordsModal } from "../../context";
import {
  DisplaySettingsModal,
  ApplyToMultipleStudentsModal,
  SyncFromToddleModal,
} from "./components";
import BulkUploadImportModal from "./components/BulkUploadImportModal";
import BulkUploadErrorModal from "./components/BulkUploadErrorModal";
import BulkUploadReviewModal from "./components/BulkUploadReviewModal";
import { BULK_UPLOAD_MODAL_TYPES } from "./modules/BulkUploadConstants";

const MODAL_TYPES = {
  DISPLAY_SETTINGS: "DISPLAY_SETTINGS",
  APPLY_TO_MULTIPLE_STUDENTS: "APPLY_TO_MULTIPLE_STUDENTS",
  SYNC_FROM_TODDLE: "SYNC_FROM_TODDLE",
  ...BULK_UPLOAD_MODAL_TYPES,
};

const AcademicRecordsModal = ({
  academicRecordsQueryRef,
  currentStudent,
  onSync,
}) => {
  const { modalInfo: { isOpen, type } = {} } = useAcademicRecordsModal();

  if (!isOpen) return null;

  switch (type) {
    case MODAL_TYPES.DISPLAY_SETTINGS:
      return (
        <DisplaySettingsModal
          academicRecordsQueryRef={academicRecordsQueryRef}
          currentStudent={currentStudent}
        />
      );
    case MODAL_TYPES.APPLY_TO_MULTIPLE_STUDENTS:
      return <ApplyToMultipleStudentsModal />;
    case MODAL_TYPES.SYNC_FROM_TODDLE:
      return <SyncFromToddleModal onSync={onSync} />;
    case MODAL_TYPES.BULK_UPLOAD_IMPORT:
      return <BulkUploadImportModal />;
    case MODAL_TYPES.BULK_UPLOAD_ERROR:
      return <BulkUploadErrorModal />;
    case MODAL_TYPES.BULK_UPLOAD_REVIEW:
      return <BulkUploadReviewModal />;
    default:
      return null;
  }
};

export default memo(AcademicRecordsModal);
